<template>
  <bita-modal
    id="role-form"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoading"
    @close="reset()"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="name"
              label="نام نقش"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.name"
              subtitle="حتما حروف لاتین وارد نمایید"
            />
            <bita-input
              type="text"
              name="fa_name"
              label="نام فارسی نقش"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.fa_name"
            />
            <bita-multiselect
              name="permissions"
              ref="permisionsMultiselect"
              label="مجوز ها"
              rules="required"
              validation-container-class="col-lg-8"
              input-class="form-control"
              :data-source="permissions"
              data-text-field="fa_name"
              data-value-field="id"
              v-model="form.permissions"
            />
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!form.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="save"
      />
      <bita-bootbutton
        v-else
        title="بروزرسانی"
        type="primary"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    title: String,
    permissions: {},
    isLoading: Boolean,
    role: {
      type: Object,
    },
  },
  data() {
    return {
      colWidth: "col-lg-4",
      form: {},
    };
  },
  mounted() {},
  watch: {
    role: function (_role) {
      this.form = _role;
    },
  },
  computed: {
    formRef() {
      return this.$refs.form;
    },
  },
  methods: {
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-create", this.form);
          this.reset();
        }
      });
    },
    update() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-update", this.form);
          this.reset();
        }
      });
    },
    reset() {
      this.$refs.permisionsMultiselect.emptyKendo();
      this.formRef.reset();
    },
  },
};
</script>
